/** Local calendar date as YYYY-MM-DD (avoids UTC off-by-one from toISOString). */
export const todayIso = () => {
  const d = new Date();
  const y = d.getFullYear();
  const m = String(d.getMonth() + 1).padStart(2, '0');
  const day = String(d.getDate()).padStart(2, '0');
  return `${y}-${m}-${day}`;
};

export const toDateOnly = (value) => {
  if (!value) return '';
  const match = String(value).match(/^(\d{4}-\d{2}-\d{2})/);
  return match ? match[1] : '';
};

/** Later of two YYYY-MM-DD strings; empty values are ignored. */
export const laterDate = (a, b) => {
  const left = toDateOnly(a);
  const right = toDateOnly(b);
  if (!left) return right;
  if (!right) return left;
  return left >= right ? left : right;
};

export const getTaskDateBounds = (projectStartDate, projectEndDate) => {
  const projectStart = toDateOnly(projectStartDate);
  const projectEnd = toDateOnly(projectEndDate);
  const min = laterDate(todayIso(), projectStart) || todayIso();
  const max = projectEnd || '';

  return { min, max, projectStart, projectEnd };
};

export const isTaskDateAvailable = (
  isoDate,
  projectStartDate,
  projectEndDate,
) => {
  const dateOnly = toDateOnly(isoDate);
  if (!dateOnly) return false;

  const { min, max } = getTaskDateBounds(projectStartDate, projectEndDate);
  if (dateOnly < min) return false;
  if (max && dateOnly > max) return false;
  return true;
};

export const getTaskDateUnavailableReason = (
  isoDate,
  projectStartDate,
  projectEndDate,
) => {
  const dateOnly = toDateOnly(isoDate);
  if (!dateOnly) return 'Invalid date';

  const today = todayIso();
  const { min, max, projectStart, projectEnd } = getTaskDateBounds(
    projectStartDate,
    projectEndDate,
  );

  if (dateOnly < today) {
    return 'Past dates cannot be scheduled';
  }
  if (projectStart && dateOnly < projectStart) {
    return 'Before project start date';
  }
  if (max && dateOnly > max) {
    return projectEnd
      ? `After project end date (${projectEnd})`
      : 'After project end date';
  }
  if (dateOnly < min) {
    return 'Outside the project schedule';
  }

  return null;
};
